import React from 'react';
import { motion } from 'framer-motion';

export const LoadingSkeleton = ({ count = 3, type = 'card' }) => {
  const skeletons = [];

  for (let i = 0; i < count; i++) {
    if (type === 'card') {
      skeletons.push(
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.1 }}
          className="glass rounded-2xl p-6"
        >
          <div className="shimmer h-48 rounded-xl mb-4"></div>
          <div className="shimmer h-6 rounded w-3/4 mb-3"></div>
          <div className="shimmer h-4 rounded w-1/2 mb-2"></div>
          <div className="shimmer h-4 rounded w-2/3"></div>
        </motion.div>
      );
    } else if (type === 'table') {
      skeletons.push(
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.1 }}
          className="space-y-3"
        >
          <div className="shimmer h-12 rounded-xl"></div>
          <div className="shimmer h-12 rounded-xl"></div>
          <div className="shimmer h-12 rounded-xl"></div>
        </motion.div>
      );
    } else {
      skeletons.push(
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.1 }}
          className="shimmer h-10 rounded-xl"
        ></motion.div>
      );
    }
  }

  return (
    <div className={type === 'card' ? 'grid md:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'}>
      {skeletons}
    </div>
  );
};